export const GET_USER_ID = "GET_USER_ID";
export const GET_COLLECTION_IMG = "GET_COLLECTION_IMG";
export const GET_GRID_IMG = "GET_GRID_IMG";
export const GEN_AI_IMAGE = "GEN_AI_IMAGE";
